<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pt-5 pt-md-4">
            
    </base-header>
        <div class="card">
          <div class="row">
            <div class="col-md-3 text-center pt-4">
              <h5>Select Range:</h5>
            </div>
            <div class="col-md-4">
              From:
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-pickr slot-scope="{focus, blur}"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{allowInput: true, dateFormat: 'd-m-Y'}"
                    class="form-control datepicker"
                    v-model="beginDate">
                    </flat-pickr>
              </base-input>
            </div>
            <div class="col-md-4">
              To:
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-pickr slot-scope="{focus, blur}"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{allowInput: true, dateFormat: 'd-m-Y'}"
                    class="form-control datepicker"
                    v-model="endDate">
                    </flat-pickr>
                    </base-input>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <base-table class="table align-items-center table-flush"                  
                  tbody-classes="list"
                  :data="events">
              <template slot="columns">
                <th>Họ Tên</th>
                <th>Ca</th>
                <th>Điểm</th>
                <th></th>
               </template>

              <template slot-scope="{row}">
                <th scope="row">
                  <div class="media align-items-center">
                  <div class="media-body">
                    <span class="name mb-0 text-sm">{{row._id.username}}</span>
                  </div>
                  </div>
                </th>
                <td class="budget">
                  {{formattime(row._id.date)}}
                </td>
                <td class="budget">
                  {{Number(row.avgmark).toFixed(2)}}
                </td>
              </template>
            </base-table>
          </div>
        </div>
  </div>
</template>
<script>
export default {
  components: {
    },
  data() {
    return {
      
    beginDate: new Date(),
    endDate: new Date(),
    }
  },
  asyncComputed: {
    async events() {
      let data = {begin:this.$moment(this.beginDate,"DD-MM-YYYY"), end: this.$moment(this.endDate,"DD-MM-YYYY")}
      let res = await this.$http.post('/mark', data)
      return res.data
    }
  },
  methods: {
    formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        return ''
      }
  },
}
</script>
<style>

</style>